export function OpenDorkWordmark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 360 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="OpenDork"
    >
      <text
        x="180"
        y="38"
        textAnchor="middle"
        fill="currentColor"
        fontFamily="'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, monospace"
        fontSize="40"
        fontWeight="700"
        letterSpacing="-0.04em"
      >
        OpenDork
      </text>
    </svg>
  );
}
